import React, { useEffect } from "react";
import { createPortal } from "react-dom";

import { CloseIcon } from "src/assets/icons/close_icon";
import { SectionTitle } from "src/components/typography/typography";
import { isNotNil } from "src/utils/type_guards";

import "./modal.scss";

/*
 * Types
 */

export interface ModalProps {
    children: React.ReactNode;
    readonly isOpen: boolean;
    readonly setOpen: (isOpen: boolean) => void;
    readonly title: string;
}

/*
 * Main
 */

const portalRoot: HTMLElement | null = document.getElementById("portal");

export const Modal = (props: ModalProps): React.ReactElement => {
    const { children, isOpen, setOpen, title } = props;

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent): void => {
            if (event.key === "Escape") {
                setOpen(false);
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return (): void => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    return (
        <>
            {isNotNil(portalRoot) &&
                createPortal(
                    isOpen && (
                        <div className="modal-outer-wrap show" id="modal">
                            <div className="modal-inner-wrap">
                                <div className="modal-title-line">
                                    <SectionTitle>{title}</SectionTitle>
                                    <div
                                        className="modal-close-button"
                                        onClick={(): void => {
                                            setOpen(false);
                                        }}
                                    >
                                        <CloseIcon />
                                    </div>
                                </div>
                                <div className="modal-divider" />
                                <div className="modal-inner-scroll-wrap">{children}</div>
                            </div>
                        </div>
                    ),
                    portalRoot,
                )}
        </>
    );
};
